<div class="loading-overlay">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 300 300"
    enable-background="new 0 0 300 300"
    xml:space="preserve"
  >
    <g class="fill">
      <g id="pushDown" class="fill" style="transform: translateY(12px)">
        /* translate Y closes the gap between M and T*/
        <rect id="replaceMorph" class="easy-end" x="100" y="75" width="100" height="48.7" style="transform-origin: 100px 75px" />
        <path
          id="M"
          style="transform-origin: 12px 73px"
          d="M228.3,123.7v-4.6v-82c0-12.6-14.8-19.4-24.3-11.2l-52.1,47.9L96,25.9c-9.6-8.2-24.3-1.4-24.3,11.2     v86.6h37.5l3.1-27.4c1-8.8,11.9-12.4,17.9-5.9l21.5,23.3l21.7-23.2c6.1-6.5,17.1-2.7,17.9,6.2l2.4,27H228.3z"
        />
      </g>

      <path
        id="T"
        style="transform-origin: 150px 180.5px"
        d="M71.7,134.4v16.8c0,3.5,2.3,6.6,5.9,6.6l0.4,0c0.6,0,1.1,0,1.5,0h7.8c24.8,0,48.1,15.8,48.1,40.7v28.1   h29.4v-24.4c0-26.9,20.8-44.3,47.7-44.3h7.8c3.5,0,7.8-3.2,7.8-6.7v-16.7H71.7z"
      />

      <path
        id="l-eye"
        style="transform-origin: 101px 207px"
        d="M101.1,220.6c7.6,0,13.7-6.1,13.7-13.7c0-7.6-6.1-13.7-13.7-13.7s-13.7,6.1-13.7,13.7   C87.4,214.4,93.5,220.6,101.1,220.6z"
      />

      <path
        id="r-eye"
        style="transform-origin: 199px 207px"
        d="M198.9,220.6c7.6,0,13.7-6.1,13.7-13.7c0-7.6-6.1-13.7-13.7-13.7c-7.6,0-13.7,6.1-13.7,13.7   C185.2,214.4,191.4,220.6,198.9,220.6z"
      />

      <path
        id="rest"
        style="transform-origin: 150px 258px"
        d="M78.2,267.7h143.6c3.6,0,6.5-3,6.5-6.7v-6.2c0-3.7-2.9-6.7-6.5-6.7H78.2c-3.6,0-6.5,3-6.5,6.7   v6.2C71.7,264.6,74.6,267.7,78.2,267.7z"
      />
    </g>
  </svg>
</div>
